<template lang="pug">
#main-container
  app-header(v-if="showMenus || showMinimalHeader" @refresh="refreshView")
  div.clearAll
  b-container(:fluid="showMenus" :key="$i18n.locale")
    b-modal#expiration-modal(
      ref="expiration-modal"
      title="Sesión expirada"
      :ok-title="$t('button.ok')"
      ok-only
      @hide="expirationModalClose") {{ $t('login.sesion.longError') }}
    b-modal#maxissues-modal(
      ref="maxissues-modal"
      :title="$t('invoices.issue.errors.freeAccount')"
      :ok-title="$t('button.ok')"
      hide-footer) 
        div(v-if="doContract === false")
          p {{ $tc('invoices.issue.errors.maxInvoicesIssuedModal', 0, [maxFreeIssuedInvoices]) }}
          div.txt-center
            b-button(variant="primary" @click="doContractPro") {{ $t('menus.topmenu.header.contract') }}
        div(v-else)
          spinner(v-if="doContractLoading === true" class="modal-spinner") 
          div(v-else)
            h4 {{ $t('menus.topmenu.header.proFunctionalities.subscription') }}
            p {{ this.doContractMsg }}
            div.txt-center
              b-button(variant="primary" @click="hideModalMaxissues") {{ $t('menus.topmenu.header.proFunctionalities.close') }}
    b-row.flex-nowrap
      .mainLeftColumn(v-if="showMenus")
        left-menu(@refresh="refreshView")
      b-col
        b-container(style="margin-top:20px")
          main#app(:class="{ 'whithout-header': !showMenus && !showMinimalHeader, 'minimal-header': showMinimalHeader }")
            router-view(:rendered="vuid")
          div.clearAll
          app-footer
</template>

<script>
  import AppHeader from '@/components/header/Header'
  import LeftMenu from '@/LeftMenu'
  import AppFooter from '@/components/Footer'
  import spinner from '@/components/shared/Spinner'
  import { getUserSubscription } from '@/utils/tokenUtils'
  import company from '@/api/apiUsersManagement/services/company'
  import config from '@/utils/config'
  import session from '@/auth/session'

  export default {
    name: 'App',
    components: {
      LeftMenu,
      AppFooter,
      AppHeader,
      spinner
    },
    data () {
      return {
        localHeight: 500,
        vuid: new Date().getTime(),
        doContract: false,
        doContractLoading: true,
        doContractMsg: ''
      }
    },
    computed: {
      showMenus: {
        get () {
          return this.$store.state.app.showMenus
        }
      },
      showMinimalHeader: {
        get () {
          return this.$store.state.app.showMinimalHeader
        }
      },
      errorSource: {
        get () {
          return this.$store.state.errors.source
        }
      },
      maxFreeIssuedInvoices: {
        get () {
          if (session.isApiLogin()) {
            return this.$store.state.me.maxIssuedInvoices
          }
        }
      }
    },
    methods: {
      refreshView () {
        this.vuid = new Date().getTime()
      },
      expirationModalClose () {
        this.$router.push({ path: '/login', query: { errorMsg: 'login.sesion.error' } })
      },
      doContractPro() {
        this.doContract = !this.doContract
        let data = {
          'address': this.$store.state.me.address.street,
          'city': this.$store.state.me.address.city,
          'corporateName': this.$store.state.me.name === null ? 'null' : this.$store.state.me.name,
          'country': this.$store.state.me.address.country,
          'email': this.$store.state.me.contactMedium.email === null ? 'null' : this.$store.state.me.contactMedium.email,
          'nif': this.$store.state.me.document === null ? 'null' : this.$store.state.me.document,
          'phone': this.$store.state.me.contactMedium.telephone === null ? '999999999' : this.$store.state.me.contactMedium.telephone,
          'postalCode': this.$store.state.me.address.postalCode,
          'region': this.$store.state.me.address.town,
          'subscription': getUserSubscription() === null ? 'null' : getUserSubscription()
        }
        console.log(data)
        company.subscription(data, config.promoterCode)
          .then((res) => {
            this.doContractMsg = this.$t('menus.topmenu.header.proFunctionalities.success')
            this.doContractLoading = false
          })
          .catch(error => {
            console.log(error)
            this.doContractMsg = `${this.$t('menus.topmenu.header.proFunctionalities.error')} ${config.supportEmail}`
            this.doContractLoading = false
          })
      },
      hideModalMaxissues() {
        this.doContract = !this.doContract
        this.$refs['maxissues-modal'].hide()
      }
    },
    watch: {
      errorSource (n) {
        if (n === 'expiration') {
          this.$refs['expiration-modal'].show()
        } else if (n === 'maxFreeIssued') {
          this.$refs['maxissues-modal'].show()
        }
      }
    },
    mounted () {
      const targetNode = document.getElementById('app')
      const target = window.parent
      const config = { attributes: true, childList: true, subtree: true }
      const vm = this

      const callback = function (mutationsList) {
        let height = targetNode.clientHeight
        if (vm.localHeight === height) return
        vm.localHeight = height
        target.postMessage({
          scope: 'altura',
          message: { height }
        }, '*')
      }
      var observer = new MutationObserver(callback)
      observer.observe(targetNode, config)
      target.postMessage({
        scope: 'altura',
        message: { height: this.localHeight }
      }, '*')
    }
  }
</script>

<style lang="scss">
body {
  width: 100%;
}
</style>